export const PIXELS = 100;
